<template>
  <div class="row" :class="overallClass" v-if="orderedEntities.length > initialPageSize">
    <div class="col-3 pagination pagination-size form-group">
      <div class="row">
        <label class="page-size-label" for="pageSize">Items per Page</label>
        <select
          name="pageSize"
          v-model="localPageSize"
          @input="changePageSize"
          class="form-control form-control-sm page-size-select">
          <option v-for="option in pageSizeOptions"
            :key="option"
            :value="option">
            {{ option }}
          </option>
        </select>
      </div>
    </div>
    <div class="col-6">
      <b-pagination
        v-model="localCurrentPage"
        @input="changeCurrentPage"
        :total-rows="rows"
        :per-page="pageSize"
        :hide-goto-end-buttons=true
        aria-controls="visible-entities"
        size="sm"
        align="center"
        prev-text="<Prev"
        next-text="Next>"
      ></b-pagination>
    </div>
    <div class="col-3 pagination-context">
      Showing {{firstVisibleEntry}}-{{lastVisibleEntry}} of {{rows}}
    </div>
  </div>
</template>
<script>

export default {
  name: 'PaginationControls',
  data() {
    return {
      localCurrentPage: this.currentPage,
      localPageSize: this.pageSize,
    };
  },
  props: {
    // the list of entities that are being paginated
    orderedEntities: Array,
    initialPageSize: Number,
    pageSize: Number,
    pageSizeOptions: Array,
    currentPage: Number,
    firstVisibleEntry: Number,
    lastVisibleEntry: Number,
    overallClass: String,
    rows: Number,
  },
  // this is a function that should be overridden by the child components.  This default is
  // just by id, so it would order by the id of the entities
  entitySort: {
    type: Function,
    default() {
      return (a, b) => a.id - b.id;
    },
  },
  methods: {
    changeCurrentPage(localCurrentPage) {
      this.$emit('update-current-page', localCurrentPage);
    },
    changePageSize(event) {
      this.$emit('update-page-size', parseInt(event.target.value, 10));
    },
  },
};
</script>
